// import ApplicantEdit from "./assessmentEdit/ApplicantEdit";
// import { getapplicantAss, getAttachment } from '../../../shared/utils/storage';
import {
  FaAddressCard,
  FaEdit,
  FaFile,
  FaIdCard,
  FaPassport,
  FaUser,
} from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { imageUrl, url } from '../../../shared/services/apiService';
import { useEffect, useState } from "react";
import { getSearchInfo } from '../../../shared/utils/storage';

const SponsorInfo = () => {
  const [application, setApplication] = useState();

  useEffect(() => {
    const searchedData = getSearchInfo();
    if (searchedData) {
      setApplication(searchedData?.data);
    }
  }, []);
  //const data = useLocation().state
  const addressInfo = application?.AddressInfo?.[0];
  const applicationInfo = application?.ApplicationInfo?.[0];
  const isFrom = applicationInfo?.ApplicationFrom;
  const sponsor = application?.MdhaminiData?.[0];
  //console.log(sponsor, "sponsor info");
  const photo = application?.AttachmentInfo?.[0];
  const imagePath = photo?.AttachmentPath
    ? `${url}get_file?path=${photo?.AttachmentPath}`
    : null;

  const styles = {
    h4: {
      color: "#850505",
      textTransform: "uppercase",
    },
  };

  return (
    <>
      <table id="viewTable">
        <tr>
          <th colspan="4">
            <h4>
              <b>Sponsor Information</b>
            </h4>
          </th>
          <th
            style={{
              textAlign: "right",
              border: "1px",
            }}
          >
            <b>
              <FaIdCard style={{ fontSize: "23px" }} />
            </b>
            {/* <ApplicantEdit /> */}
          </th>
        </tr>
        <tr>
          <td style={{ width: "20%" }} colSpan={2}>
            Jina Kamili: <br /> <h4 style={styles.h4}>{sponsor?.FullName}</h4>
          </td>
          <td style={{ width: "20%" }}>
            Jinsia: <br /> <h4 style={styles.h4}>{sponsor?.Gender}</h4>
          </td>
          <td style={{ width: "20%" }}>
            Tarehe Ya Kuzaliwa: <br />{" "}
            <h4 style={styles.h4}>{sponsor?.DateOfBirth}</h4>
          </td>

          <td rowspan="4" style={{ width: "0%", textAlign: "center" }}>
            <div className="col-sm-3">
              <div className="row">
                {isFrom == 4 ? (
                  sponsor?.PhotoImage ? (
                    <img
                      src={`data:image/jpg;base64,${sponsor?.PhotoImage}`}
                      className="img-thumbnail center-block declaration-image"
                      style={{ height: "200px", maxWidth: "250px" }}
                      alt="Sponsor photo"
                    />
                  ) : (
                    <p>No image available</p>
                  )
                ) : sponsor?.PhotoPath ? (
                  <img
                    src={`data:image/jpg;base64,${sponsor?.PhotoPath}`}
                    className="img-thumbnail center-block declaration-image"
                    style={{ height: "200px", maxWidth: "250px" }}
                  />
                ) : (
                  <p>No image available</p>
                )}
                {/* {sponsor?.PhotoPath ? (
                                    <img src={sponsor?.PhotoPath} width="220px" height="250px" alt="User uploaded photo" />
                                ) : (
                                    <>{sponsor?.PhotoPath ? (
                                        <img
                                            src={`data:image/jpg;base64,${sponsor.PhotoPath}`}

                                            style={{ height: "200px" }}

                                        />
                                    ) : (
                                        <p>No image available</p>
                                    )}</>
                                )} */}

                {/* {sponsor?.PhotoImage ? (
                                    <img
                                        src={`data:image/jpg;base64,${sponsor?.PhotoImage}`}
                                        className="img-thumbnail center-block declaration-image"
                                        style={{ width: "120px", height: "140px" }}
                                    />
                                ) : (<>
                                    {sponsor?.AttachmentPath ? (
                                        <img
                                            src={`${url}get_file?path=${sponsor?.AttachmentPath}`}
                                            className="img-thumbnail center-block declaration-image"
                                            style={{
                                                width: "110px",
                                                height: "130px",
                                            }}
                                        />
                                    ) : (
                                        <p>No image available</p>
                                    )}</>
                                )} */}
              </div>
            </div>

            {/* <img src="http://localhost:5000/20241230140817.jpg" width="220px" height="250px" /> */}
          </td>
        </tr>

        <tr>
          <td style={{ width: "20%" }} colSpan={2}>
            Nchi: <br /> <h4 style={styles.h4}>{sponsor?.CountryOfBirth}</h4>
          </td>
          <td style={{ width: "20%" }}>
            Mkoa: <br /> <h4 style={styles.h4}>{sponsor?.RegionalOfBirth}</h4>
          </td>
          <td style={{ width: "20%" }}>
            Wilaya: <br /> <h4 style={styles.h4}>{sponsor?.DistrictOfBirth}</h4>
          </td>
        </tr>
      </table>
    </>
  );
};

export default SponsorInfo;
